import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SIGNUP_REGISTER_PATH, MAP_SETUP_PATH } from '../../install/shared/navigation/constants';
import { AccountService } from '../../shared/services/account.service';
import { Observable } from 'rxjs/Rx';
import { updateWebsite } from './state/platform_actions_creator';
import { Store } from '@ngrx/store';
import { PlatformState } from './state/platform_state';
import { concatMap, map, take } from 'rxjs/operators';
import { AuthService } from '@yotpo-ui/core';
import { of } from 'rxjs';

@Injectable()
export class PlatformGuard implements CanActivate {

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private router: Router,
    private store: Store<PlatformState>
  ) { }

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticatedAsync().pipe(
      concatMap(isAuthenticated => {
        if (isAuthenticated) {
          return this.navigateByAccountPlatform();
        } else {
          this.router.navigateByUrl(SIGNUP_REGISTER_PATH);
          return of(false);
        }
      })
    );
  }

  private navigateByAccountPlatform(): Observable<boolean> {
    return this.accountService.getAppData().pipe(take(1), map(
      (response) => {
        let domain = response.response.app.domain;
        let account_platform = response.response.app.account_platform;

        if (domain) {
          if (account_platform) {
            this.router.navigateByUrl(MAP_SETUP_PATH);
          } else {
            this.store.dispatch(updateWebsite({ website: domain }));
          }
        }

        return true;
      }));
  }
}
